import { render, staticRenderFns } from "./ModalRedefinirSenha.vue?vue&type=template&id=1a05ce38"
import script from "./ModalRedefinirSenha.vue?vue&type=script&lang=js"
export * from "./ModalRedefinirSenha.vue?vue&type=script&lang=js"
import style0 from "./ModalRedefinirSenha.vue?vue&type=style&index=0&id=1a05ce38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports